var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block info-data"},[_c('h2',[_c('i',{staticClass:"sr-icon-box-shield"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.heading)}})]),(_vm.autoSsl)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.info)}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }